module.exports = __webpack_public_path__ + "static/media/payment-result-failed.c1d8338c.jpg";